import { Component, Input, OnChanges, AfterViewInit,
    EventEmitter, Output, SimpleChanges, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';

@Component({
    selector: "progressive-image",
    templateUrl: "./progressive-image.component.html",
    styleUrls: ["./progressive-image.component.scss"],
    encapsulation: ViewEncapsulation.None
})
export class ProgressiveImage implements OnChanges, AfterViewInit{
    @Input("bigImage") bigImage: string;    
    @Input("smallImage") smallImage: string; 
    @Input() public imgClass = "";

    public src = '';
    public loaded = false;
    public alt = "";
    public bigImageSrc = "";
    public mainImageClass: string = "";

    constructor(@Inject(PLATFORM_ID) private platformId:Object){}

    ngOnChanges(changes:SimpleChanges){
        this.src = this.smallImage;
        if(!isPlatformServer(this.platformId)){      
            this.bigImageSrc = this.bigImage;
            this.loaded = false;
        }
      
        this.mainImageClass = this.imgClass + " sn-img-main";
    }

    ngAfterViewInit() {
        if(!isPlatformServer(this.platformId)){
            
        }
    }

    /**
     * When big image is loaded
     */
    onImagePreload() {
        this.src = this.bigImage;
        this.loaded = true;
    }

    onImagePreloadError(){

    }
}